import { CountriesAndTimeZonesData } from "@/api/base"
import { ITrackingPageOptions, ThemeLayoutEnum } from "@/models/ITrackingPageOptions"
import type {
  TrackingPageSaveThemeConfigRequestBody,
  TrackingPageThemeConfigGetResponse,
  TrackingPageThemeConfigSaveResponse,
  TrackingPageThemeLayoutInlinePayload,
  TrackingPageThemePreviewListResponse,
  TrackingPageThemePreviewResponse,
} from "@/models/ITrackingPageThemeLayoutConfig"
import baseRequest from "@/utils/baseRequest"
import request, { graphqlShopifyRequest } from "@/utils/request"

const GRAPHQL_ENDPOINT = "https://atlas.shopifysvc.com/graphql"

export const queryCountriesAndTimeZones = `
  query CountriesAndTimeZones($locale: SupportedLocale!) {
    countries(locale: $locale) {
      code
      continent
      currencyCode
      name
      provinceKey
      provinces {
        name
        code
      }
    }
    timeZones(locale: $locale) {
        olsonName,
        description
    }
  }
`

export default {
  /**
   * 获取基础配置信息
   */
  baseInfo() {
    return baseRequest.get("v2/tracking_page/config")
  },

  productCollects() {
    return request.get("tracking-page/collects")
  },

  /**
   * 保存配置信息
   * @param changeDateArr
   */
  save(changeDateArr: Partial<ITrackingPageOptions>) {
    return request.post("tracking-page/save", { changeDateArr })
  },

  fetchCountriesAndTimeZones(variables: { locale: string }) {
    return graphqlShopifyRequest<CountriesAndTimeZonesData>(GRAPHQL_ENDPOINT, queryCountriesAndTimeZones, variables)
  },

  /**
   * 获取指定主题布局的 `theme` + `theme_config`；路径 `:theme` 为数值 **2** 或 **3**。
   */
  getThemeConfig(theme: ThemeLayoutEnum) {
    return baseRequest.get<TrackingPageThemeConfigGetResponse>(`v2/tracking_page/theme_config/${theme}`)
  },

  /**
   * 保存主题布局配置；路径 `:theme` 为数值 **2** 或 **3**；`config` 可为完整载荷或仅 `theme_config`。
   */
  saveThemeConfig(
    theme: ThemeLayoutEnum,
    config: TrackingPageSaveThemeConfigRequestBody["tracking_page_theme_config"] | TrackingPageThemeLayoutInlinePayload,
  ) {
    const body: TrackingPageSaveThemeConfigRequestBody = { tracking_page_theme_config: config }

    return baseRequest.put<TrackingPageThemeConfigSaveResponse>(`v2/tracking_page/theme_config/${theme}`, body)
  },

  getThemePreview(theme: ThemeLayoutEnum) {
    return baseRequest.get<TrackingPageThemePreviewResponse>(`v2/tracking_page/theme_config/preview?theme=${theme}`)
  },

  /**
   * 获取全部主题布局（Classic / Backdrop / Showcase）的预览链接列表，用于缩略图 iframe。
   */
  getThemePreviewList() {
    return baseRequest.get<TrackingPageThemePreviewListResponse>("v2/tracking_page/theme_config/preview_list")
  },
}


